module.exports = __webpack_public_path__ + "img/solution-bg-app.236de370.jpg";